import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar, { scrollToId } from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import TwoPaths from "@/components/TwoPaths";
import HowItWorks from "@/components/HowItWorks";
import Plans from "@/components/Plans";
import SpecialMoments from "@/components/SpecialMoments";
import GroupTeaser from "@/components/GroupTeaser";
import AboutFaqs from "@/components/AboutFaqs";
import TechPlatform from "@/components/TechPlatform";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { websiteSchema, agencySchema, navigationSchema, faqSchema } from "@/seo/schemas";
import api from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

export default function Home() {
  const [settings, setSettings] = useState(null);
  const { t } = useLang();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const timer = setTimeout(() => {
        scrollToId(target);
        navigate("/", { replace: true, state: {} });
      }, 400);
      return () => clearTimeout(timer);
    }
  }, [location.state, navigate]);

  return (
    <div data-testid="home-page">
      <Seo page="home" jsonLd={[websiteSchema(), agencySchema(settings), navigationSchema(), faqSchema(t("faq.items"))]} />
      <Navbar />
      <Hero settings={settings} />
      <Marquee />
      <TwoPaths />
      <HowItWorks />
      <Plans />
      <SpecialMoments />
      <GroupTeaser />
      <AboutFaqs />
      <TechPlatform />
      <Faq />
      <Contact settings={settings} />
      <Footer settings={settings} />
    </div>
  );
}
